import { forwardRef, React, useEffect, useImperativeHandle, useRef, useState } from 'react';
import FormCreator from '../../../../components/Forms/FormCreator';
import ProfessionalCertificationDataGeneral from './data/ProfessionalCertification.data';
import { onMembershipTypeAndCheckBox } from '../../utils/setEditFieldsUtils';


const ProfessionalCertification = forwardRef(({ handleFieldChange, getMemberDetailsData }, ref) => {
    const personalInformationFormRef = useRef();
    const [checkBox3, setCheckBox3] = useState(ProfessionalCertificationDataGeneral?.initialState?.checkBox3 || false);
    const [formData, setFormData] = useState(ProfessionalCertificationDataGeneral);


    useEffect(() => {
        if (!checkBox3 && getMemberDetailsData) {
            const updatedFormData = { ...formData };
            updatedFormData.initialState.yearsOfProfessionalPracticeIS = getMemberDetailsData?.yearsOfProfessionalPracticeInIS || null;
            setFormData(updatedFormData);
        }
    }, [getMemberDetailsData, checkBox3]);


    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const data = personalInformationFormRef.current.getFormData();
                return data;
            }
            return null;
        }
    }));

    const handleDataFieldChange = (fieldName, value) => {
        if (fieldName === "checkBox3") {
            setCheckBox3(value);
            const updatedFormData = onMembershipTypeAndCheckBox(value);

            setFormData(prev => ({
                ...prev,
                formFields: updatedFormData.formFields || prev.formFields,
                initialState: {
                    ...updatedFormData.initialState,
                    checkBox3: value,
                },
            }));
        }
    };





    return (
        <div className="form-field-sec">
            <div className="row gx-5">
                <FormCreator
                    key={checkBox3}
                    ref={personalInformationFormRef}
                    {...formData}
                    onFormFieldValueChange={handleDataFieldChange}
                ></FormCreator>
            </div>
        </div>
    )
})

export default ProfessionalCertification